module.exports = __webpack_public_path__ + "static/media/davis-events.f5d0886b.png";